// @flow

import * as React from 'react';
import styles from './FilterMenuContent.module.css';

type Props = {
  children: React.Node,
};

const FilterMenuContent = ({ children }: Props) => (
  <div className={styles.root}>{children}</div>
);

export default FilterMenuContent;
